/* eslint-disable */
import moment from 'moment';
import 'moment/locale/ru';
import {propsDecorator} from '@/js/common/Domain/Service/mixins/decorators';

@propsDecorator({
	defaults: {
		selectedIdentity: null,
		subscribed: false,
		hotelInfo: null,
		activeTab: 'tours', // tours, hotels
		tourSearchModel: null,
		mapHotelsSearchModel: null,
		tourSearchCriteria: null,

		minPriceBySearchDates: null,
		minPriceOilTaxBySearchDates: null,
		showHotelCashbackBanner: false,
	},
	computeds: {
		htmlTourSearchCriteria: {
			deps: ['tourSearchCriteria'],
			get(tourSearchCriteria) {
				let html = '';
				if (!tourSearchCriteria) {
					return html;
				}
				const json = tourSearchCriteria.toJSON();
				const searchData = {
					checkInDateRange: json.checkInDateRange.toJSON(),
					touristGroup: json.touristGroup.toJSON(),
					nightRange: json.nightRange.toJSON(),
					get children() {
						const children = this.touristGroup.infants + this.touristGroup.kids;
						if (!children) {
							return '';
						}
						return `, ${children} ${children.wordEnding(`${this.touristGroup.infants ? 'младенец' : 'ребенок'};детей;детей`)}`;
					},
					get nights() {
						const {nightRange} = this;
						let result = ` ${nightRange.from}`;
						if (nightRange.from !== nightRange.to) {
							result += `—${nightRange.to}`;
						}
						result += ` ноч${nightRange.to.wordEnding('ь;и;ей;')}`;
						return result;
					},
				};
				html += `${searchData.touristGroup.adults} взрослы${searchData.touristGroup.adults.wordEnding('й;х;х')}${searchData.children}<br>`;
				html += `c ${moment(searchData.checkInDateRange.from).format('DD MMMM')}${searchData.nights}`;
				return html;
			},
		},
	},
})
export default class HotelPageModel extends Backbone.Epoxy.Model {
	initialize() {
		this.initModelEvents();
	}

	initModelEvents() {
		this.on('change:tourSearchModel', (model, tourSearchModel) => {
			tourSearchModel.on('change:syncTourProducts', this.syncTourProductsChanged.bind(this));
            tourSearchModel.on('change:filteredTourProducts', this.syncShowHotelCashbackBanner.bind(this));
		});
	}

    syncShowHotelCashbackBanner(tourSearchModel, filteredTourProducts) {
        const cashbackAvailableAppConfig = !!window?.appConfig?.cashbackAvailable;
        const cashbackAvailable = cashbackAvailableAppConfig && !!filteredTourProducts?.some((tourProduct) => tourProduct?.get('tour')?.get('cashbackAvailable'));
        this.set('showHotelCashbackBanner', cashbackAvailable);
    }

	syncTourProductsChanged() {
		const tourSearchModel = this.get('tourSearchModel');
		const syncTourProducts = tourSearchModel.get('syncTourProducts');
		const checkInDateRange = tourSearchModel.get('searchData').get('checkInDateRange');
		const checkInDateRangeFrom = checkInDateRange?.get('from');
		const checkInDateRangeTo = checkInDateRange?.get('to');
		let minPriceOilTax = 0;
		let minPrice = 0;

		if (syncTourProducts?.length && checkInDateRangeFrom.getTime() === checkInDateRangeTo.getTime()) {
			const selectedDate = moment(checkInDateRangeFrom).format('YYYY-MM-DD');
			const syncTourProductsByCurrentDate = tourSearchModel.filterTourProductsByDate(syncTourProducts.models, selectedDate);
			const minPricesyncTourProductsByCurrentDate = _.min(syncTourProductsByCurrentDate, tourProduct => tourProduct.get('tour').get('priceWithOilTax'));

			if (minPricesyncTourProductsByCurrentDate && minPricesyncTourProductsByCurrentDate !== Infinity) {
				minPrice = minPricesyncTourProductsByCurrentDate.get('tour').get('priceWithOilTax');
				minPriceOilTax = minPricesyncTourProductsByCurrentDate.get('tour').get('oilTax');
			}
		} else {
			minPrice = tourSearchModel.get('minPriceSyncTourProducts') || 0;
			minPriceOilTax = tourSearchModel.get('minPriceSyncTourProductsOilTax') || 0;
		}

		this.set('minPriceBySearchDates', minPrice);
		this.set('minPriceOilTaxBySearchDates', minPriceOilTax);
	}
}
